import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@remote/assets/img/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-3b0c6311"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.92186 9.69375C6.44211 10.2695 5.55789 10.2695 5.07813 9.69375L1.64018 5.56821C0.988856 4.78661 1.54464 3.59999 2.56205 3.59999L9.43795 3.59999C10.4554 3.59999 11.0111 4.78662 10.3598 5.56821L6.92186 9.69375Z" })
], -1))
const _hoisted_3 = { class: "header-search-box" }
const _hoisted_4 = { class: "header-right" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.8335 2.83334H3.3335H12.6687H13.1687V3.83334H12.6687H3.3335H2.8335V2.83334ZM2.8335 7.50001H3.3335H12.6687H13.1687V8.50001H12.6687H3.3335H2.8335V7.50001ZM3.3335 12.1667H2.8335V13.1667H3.3335H12.6687H13.1687V12.1667H12.6687H3.3335Z",
    fill: "#212429"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备详情", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "磁盘管理", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设置", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "帮助反馈", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 10L8 6L4 2",
    stroke: "#212429",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("在线客服")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sublabel" }, "（8:00~24:00）", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("客服热线"),
  /*#__PURE__*/_createElementVNode("span", { class: "sublabel" }, "（8:00~24:00）")
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "提交工单", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "关于", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 10L8 6L4 2",
    stroke: "#212429",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1))
const _hoisted_26 = [
  _hoisted_25
]

import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { isAndroidNative as isAndroid, isIOSNative as isIOS, sendMessage } from '@xunlei/universal-native-api'
import { IconHome } from '@xunlei/thunder-icon-vue'
import { TdVipBadge } from '@xunlei/thunder-ui-vue3/dist/VipBadge'
import '@xunlei/thunder-ui-vue3/dist/VipBadge/styles/VipBadge.css'
import { CUSTOM_SERVICE_URL, SUBMIT_QUESTION_URL, SYNOLOGY_HELP_URL } from '@remote/constant/index'
import { HotlineTelNumber } from '@remote/constant'
import { useEnvStore } from '@remote/store/env'
import { toast, openDeviceViewer, openHeziSettings, openDeviceList } from '@remote/utils/dialog'
import modal from '@remote/components/modal'
import { E_SETTING_TAB } from '@remote/views/settings/modal/helper'
import HeziClientMenubar from './HeziClientMenubar.vue'
import {isHeziPCClient} from '@remote/utils/hezi-pc-client'
import SearchBox from '@remote/components/layout/SearchBox.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const envStore = useEnvStore()
const router = useRouter()
const showDropMenus = ref(false)

const handleToggleDropMenus = (visible) => {
  if (visible === void 0) {
    showDropMenus.value = !showDropMenus.value
  } else {
    showDropMenus.value = !!visible
  }
}

const isLogin = computed(() => {
  return store.getters['isLogin']
})

const currentDeviceName = computed(() =>store.state.curDeviceRunner.name)

const isVip = computed(() => {
  return store.getters['isVip']
})
const user = computed(() => {
  return store.state.user
})

const avatarURL = computed(() => {
  return store.state.user?.avatarURL || 'https://xfile2.a.88cdn.com/file/k/avatar/default'
})

const nickName = computed(() => {
  return store.state.user?.nickName
})

const disabled = computed(() => {
  return store.state.isSelect
})

const isNative = computed(() => {
  return (isAndroid || isIOS || store.state.isApp || store.state.isMiniProgram) && self === top
})

const showPersonal = computed(() => {
  return router.currentRoute.value.name !== 'login'
})

const isVisibleSearchBox = computed(() => {
  return router?.currentRoute?.value?.name && ['cinema', 'cinemaSearch'].includes(router?.currentRoute?.value?.name as string)
})

const isDeviceBindPage = computed(() => {
  return router.currentRoute.value.name === 'deviceBind'
})

const isInXunlei = computed(() => {
  return envStore.isInPC || isAndroid || isIOS
})

const callAppHome = () => {
  let routename = String(router.currentRoute.value.name)
  if (!isNative.value) return
  if (!['home', 'login', 'me', 'album'].includes(routename)) {
    router.back()
  } else {
    store.dispatch('close')
  }
}

const logout = () => {
  modal.show({
    title: '确认要退出登录吗？',
    actions: [{
      id: 'logout',
      text: '退出登录',
      callback: () => {
        store.dispatch('logout', true)
      },
    }],
  })
}

const gotoDeviceInfo = () => {
  // router.push({
  //   name: 'deviceInfo',
  //   query: router.currentRoute.value.query,
  // })
  openDeviceViewer({ closeOnMaskClick: false })
}

const gotoDisk = () => {
  router.push({
    name: 'disks',
    query: router.currentRoute.value.query,
  })
}

// const gotoServicePage = () => {
//   router.push({
//     name: 'services',
//     query: router.currentRoute.value.query,
//   })
// }

const gotoSettingPage = () => {
  openHeziSettings({
    defaultActiveKey: E_SETTING_TAB.transmission,
    mask: true,
    closeOnMaskClick: false,
  })
  // router.push({
  //   name: 'moreInfo',
  //   query: router.currentRoute.value.query,
  // })
}

const gotoCustomerService = () => {
  window.open(CUSTOM_SERVICE_URL, '_blank', 'width=920')
  // store.commit('update', { currentIframeUrl: CUSTOM_SERVICE_URL, currentIframeTitle: '在线客服', currentIframeShowClose: false })
  // router.push({
  //   name: 'pluginIframe',
  //   query: router.currentRoute.value.query,
  // })
}

const gotoHotline = () => {
  if (isIOS) {
    sendMessage({
      platform: 'ios',
      name: 'openURL',
      params: {
        url: `tel:${HotlineTelNumber}`,
        title: '客服热线',
      },
    }, { noCallback: true })
  } else if (isAndroid) {
    location.href = `tel:${HotlineTelNumber}`
  } else {
    toast(`客服热线：${HotlineTelNumber}`)
  }
}

const gotoProtocol = (url: string, title: string) => {
  window.open(url)
  // store.commit('update', { currentIframeUrl: url, currentIframeTitle: title, currentIframeShowClose: false })
  // router.push({
  //   name: 'pluginIframe',
  //   query: router.currentRoute.value.query,
  // })
}

const gotoSubmit = () => {
  if (isAndroid) {
    return sendMessage({
      platform: 'android',
      name: 'xlOpenUrl',
      params: {
        url: SUBMIT_QUESTION_URL,
        openType: 1,
        from: '',
      },
    })
  }
  else if (isIOS) {
    setTimeout(() => {
      location.assign(
        `xunlei://hybrid/openHybridWeb?url=${decodeURIComponent(SUBMIT_QUESTION_URL)}`,
      )
    }
    , 1000)
    return
  }
  gotoProtocol(SUBMIT_QUESTION_URL, '提交工单')
}

const gotoHelp = () => {
  if (isAndroid) {
    return sendMessage({
      platform: 'android',
      name: 'xlOpenUrl',
      params: {
        url: SYNOLOGY_HELP_URL,
        openType: 1,
        from: '',
      },
    })
  }
  else if (isIOS) {
    setTimeout(() => {
      location.assign(
        `xunlei://hybrid/openHybridWeb?url=${decodeURIComponent(SYNOLOGY_HELP_URL)}`,
      )
    }
    , 1000)
    return
  }
  gotoProtocol(SYNOLOGY_HELP_URL, '帮助文档')
}

const goAbout = () => {
  router.push({
    name: 'about',
    query: router.currentRoute.value.query,
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", { 'is-disabled': _unref(disabled), 'android-padding': _unref(isAndroid), 'ios-padding': _unref(isIOS), 'is-vip': _unref(isVip) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref(isNative))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "header-logo",
            onClick: callAppHome,
            src: _imports_0,
            alt: "logo"
          }))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "header-home",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openDeviceList) && _unref(openDeviceList)(...args)))
          }, [
            _createVNode(_unref(IconHome), {
              width: "36",
              height: "36",
              onClick: _withModifiers(callAppHome, ["stop"])
            }, null, 8, ["onClick"]),
            _createTextVNode(" " + _toDisplayString(_unref(currentDeviceName)) + " ", 1),
            _hoisted_2
          ]))
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(SearchBox)
    ], 512), [
      [_vShow, _unref(isVisibleSearchBox)]
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_unref(showPersonal))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "personal",
            onMouseenter: handleToggleDropMenus
          }, [
            _createElementVNode("img", {
              src: _unref(avatarURL),
              class: "avatar",
              alt: "头像"
            }, null, 8, _hoisted_5),
            _createElementVNode("section", null, [
              _createElementVNode("p", {
                class: _normalizeClass(["nickName", { 'is-vip': _unref(user)?.isVip }])
              }, _toDisplayString(_unref(nickName)), 3),
              _createVNode(_unref(TdVipBadge), {
                "vip-level": _unref(user)?.vipLevel,
                "is-vip": _unref(user)?.isVip,
                "is-year": _unref(user)?.isYear,
                "vas-type": _unref(user)?.vipType,
                size: "large"
              }, null, 8, ["vip-level", "is-vip", "is-year", "vas-type"]),
              _hoisted_6
            ]),
            _withDirectives(_createElementVNode("ul", {
              class: "menus",
              onClick: _cache[1] || (_cache[1] = () => handleToggleDropMenus(false))
            }, [
              (!_unref(isDeviceBindPage))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("li", {
                      class: "select_item",
                      onClick: gotoDeviceInfo
                    }, _hoisted_8),
                    _createElementVNode("li", {
                      class: "select_item",
                      onClick: gotoDisk
                    }, _hoisted_10),
                    _createElementVNode("li", {
                      class: "select_item",
                      onClick: gotoSettingPage
                    }, _hoisted_12)
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("li", { class: "select_item submenus feedback_item" }, [
                _hoisted_13,
                _hoisted_14,
                _createElementVNode("ul", { class: "menus" }, [
                  _createElementVNode("li", { class: "select_item" }, [
                    _createElementVNode("span", { onClick: gotoCustomerService }, _hoisted_17)
                  ]),
                  _createElementVNode("li", {
                    class: "select_item",
                    onClick: gotoHotline
                  }, _hoisted_19),
                  _createElementVNode("li", {
                    class: "select_item feedback",
                    onClick: gotoSubmit
                  }, _hoisted_21)
                ])
              ]),
              (_unref(isInXunlei))
                ? (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    class: "select_item bottom_line",
                    onClick: goAbout
                  }, _hoisted_24))
                : _createCommentVNode("", true),
              _createElementVNode("li", {
                class: "select_item",
                onClick: logout
              }, _hoisted_26)
            ], 512), [
              [_vShow, showDropMenus.value]
            ])
          ], 32))
        : _createCommentVNode("", true),
      (!!_unref(isHeziPCClient)())
        ? (_openBlock(), _createBlock(HeziClientMenubar, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})